<template>
  <div class="flex">
      <button @click="back">返回上一页</button>
      <div class="label">当前位置：</div>
      <el-breadcrumb separator="/">
        <el-breadcrumb-item v-for="(item,i) in routerList" :key="i" :to="(i+1)!=routerList.length?{ path: item.path||'',query:item.query||{}  }:{}">{{item.meta&&item.meta.name}}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
</template>

<script>
import {mapState}from 'vuex';
export default {
  computed:{
    ...mapState('routerData',['routerList']),
    newdata(){
      return this.routerList
    }
  },
  methods:{
    back(){
        this.$router.back();
    }
  }
}
</script>

<style lang="less" scoped>
 button{
    height: 33px;
    line-height: 33px;
    background: #ed9d26;
    border-radius: 7px;
    padding:0 10px;
    font-size: 18px;
    color: #ffffff;
    border:none;
    margin-right: 32px;
    cursor: pointer;
  }
.label{
  font-size: 20px;
  color: #666666;
}
::v-deep .el-breadcrumb{
  font-size: 20px;
}

::v-deep .el-breadcrumb__inner a:hover, ::v-deep .el-breadcrumb__inner.is-link:hover {
  color:#ED9D26;
  cursor: pointer;
}
</style>